import PropTypes from 'prop-types';
import React from 'react';
import { Layout as BaseLayout } from 'antd';

import Menu from '../header/menu';
import Footer from '../footer';
import Header from '../header/header';

const Layout = ({ children }) => (
  <BaseLayout>
    <Menu />
    <Header />
    {children}
    <Footer />
  </BaseLayout>
);

Layout.propTypes = {
  children: PropTypes.any,
};

export default Layout;
